import { Injectable } from '@angular/core';

// Environment reponse
export class EnvironmentDataResponse {
  environment: string;
  appPath: string;
  gRecaptchaSiteKey: string;
  passwordPolicy: PasswordPolicy;
  amContext: string;
  endPoints: EndPoints;
  logKeys: LogKeys;
}

export class EndPoints {
  log: string;
  passwordChangeRequest: string;
  validateToken: string;
  validatePassword: string;
  changePassword: string;
}

export class PasswordPolicy {
  minLength: string;
  maxLength: string;
  minUppercase: string;
  minLowercase: string;
  minDigits: string;
  minHistory: string;
  minSymbols: string;
}

export class LogKeys {
  logKey0: string;
  logKey1: string;
  logKey2: string;
  logKey3: string;
  logKey4: string;
  logKey5: string;
  logKey6: string;
  logKey7: string;
  logKey8: string;
  logKey9: string;
}

// general data
export class DataResponse {
  data: any[];
  token: string;
}

// Change password request reponse
export class AltEmailDataResponse extends DataResponse {
  data: AlternativeEmail[];
}
export class AlternativeEmail {
  altemail: string;
}

// Validate token repsonse
export class TokenDataResponse extends DataResponse {
  data: UserData[];
}
@Injectable()
export class UserData {
  idp: string;
  username: string;
  displayName: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  altemail: string;
  language: string;
  tokensession: string;
  public constructor() { }

  public deleteUserData() {
    this.idp = undefined;
    this.username = undefined;
    this.displayName = undefined;
    this.name = undefined;
    this.firstName = undefined;
    this.lastName = undefined;
    this.email = undefined;
    this.altemail = undefined;
    this.language = undefined;
    this.tokensession = undefined;
  }
}

// Validate password repsonse
export class ValidatePasswordDataResponse extends DataResponse {
  data: ValidatePasswordData[];
}
export class ValidatePasswordData {
  username: string;
  tokensession: string;
}
